const initialState = {
  bookingOrderResult: {},
};

// 立即下单页面接口
export default function receivebookingOrderResult(state = initialState, action) {
  switch (action.type) {
  case 'SHOW_ORDER_BOOKING':
    return { ...state, bookingOrderResult: action.payload };
  default:
    return state;
  }
}